

























































































import QuoteStateMixin from '@/mixins/quoteState';
import { mapActions } from 'vuex';
import { QuoteState } from '@/models/quote';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default mixins(QuoteStateMixin, auth).extend({
  components: { ErrorAlert },
  name: 'QuoteSubmittedStateCard',

  computed: {
    getColor(): string {
      return 'submitted';
    },

    getIcon(): string {
      return 'mdi-file-send-outline';
    },

    getString(): string {
      return 'Submitted for review';
    },

    getActionText(): string {
      return 'Start review';
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState'
    }),

    undoSubmit() {
      return this.setState(QuoteState.DRAFT);
    },
    startReview() {
      return this.setState(QuoteState.IN_REVIEW);
    },

    setState(state: QuoteState) {
      this.clearAllErrors();

      this.loading = true;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
